"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsalLayer = void 0;
const msal_browser_1 = require("@azure/msal-browser");
const msal_common_1 = require("@azure/msal-common");
class MsalLayer {
    constructor(config) {
        this.msalInstance = new msal_browser_1.PublicClientApplication(config);
    }
    get instance() {
        return this.msalInstance;
    }
    async loginPopup(scopes = new msal_common_1.ScopeSet([
        "user.read",
        "openid",
        "profile",
        "email",
    ]), popupConfig) {
        return await this.msalInstance.loginPopup({
            scopes: scopes.asArray(),
            popupWindowAttributes: popupConfig,
            prompt: "select_account",
        });
    }
    async loginRedirect(scopes = new msal_common_1.ScopeSet(["user.read", "openid", "profile", "email"])) {
        const response = await this.msalInstance.handleRedirectPromise();
        await this.msalInstance.loginRedirect({
            scopes: scopes.asArray(),
            prompt: "select_account",
        });
        return response;
    }
    async logout() {
        return await this.msalInstance.logoutPopup();
    }
    user() {
        const currentAccounts = this.msalInstance.getAllAccounts();
        // no user has signed in
        if (!currentAccounts || currentAccounts.length === 0)
            return undefined;
        // improvements in future could be to handle this a bit cleaner... but for now it's fine.
        return currentAccounts[0];
    }
    async acquireToken(scopes = new msal_common_1.ScopeSet(["user.read"])) {
        let resp;
        try {
            resp = await this.msalInstance.acquireTokenSilent({
                scopes: scopes.asArray(),
                account: this.user(),
            });
        }
        catch (err) {
            // silent sometimes fails, so let's just try popup
            resp = await this.msalInstance.acquireTokenPopup({
                scopes: scopes.asArray(),
                account: this.user(),
            });
        }
        return resp;
    }
    isAuthenticated() {
        const accounts = this.msalInstance.getAllAccounts();
        return accounts && accounts.length > 0;
    }
}
exports.MsalLayer = MsalLayer;
